export default __webpack_public_path__ + "images/47dd1f8e5bd5826ad628ee61a9d2d406.svg";